export default __webpack_public_path__ + "static/gatsby_default_starter-bc4853f2b0cc80dd1f6325b25c39f891.png";